module.exports = __webpack_public_path__ + "static/img/icomoon.c49f276a.svg";